import React from 'react';
import classNames from 'classnames';
import { Stack } from 'react-bootstrap';
import { toBoolean } from 'shared/utils/functions';
import Input, { readOnlyAttrs } from './Input';
import Label from './Label';

/**
 * @type {import('./types').FieldTransformStrategy}
 */
const transform = {
  fromServer(value) {
    return toBoolean(value);
  },
  toServer(value) {
    const payload = value;
    return payload;
  },
  defaultValue(value) {
    return toBoolean(value);
  },
};

const Checkbox = React.memo(function Checkbox(props) {
  const { name, displayName, required = false, readOnly } = props;
  return (
    <Stack direction="horizontal" className="mb-3">
      <Input
        type="checkbox"
        id={name}
        className={classNames(
          'me-2',
          readOnly && 'bg-light text-muted cursor-not-allowed'
        )}
        {...(readOnly && readOnlyAttrs)}
        {...props}
      />
      <Label htmlFor={name} required={required} readOnly={readOnly}>
        {displayName}
      </Label>
    </Stack>
  );
});

Checkbox.transform = transform;
export default Checkbox;
